import PersonBlock from './PersonBlock'

export default PersonBlock
